"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const NotFound_1 = __importDefault(require("./NotFound"));
const react_bootstrap_1 = require("react-bootstrap");
const URLs_1 = require("../utility/URLs");
const TopMenue_1 = __importDefault(require("../components/TopMenue"));
const URLs_2 = require("../utility/URLs");
const LoginPage_1 = __importDefault(require("./LoginPage"));
const Home_1 = __importDefault(require("./Home"));
const PageCreator_1 = __importDefault(require("../page/PageCreator"));
const PagesIndex_1 = __importDefault(require("../page/PagesIndex"));
const PageShow_1 = __importDefault(require("../page/PageShow"));
const PageEditor_1 = __importDefault(require("../page/PageEditor"));
const BookCreator_1 = __importDefault(require("../book/BookCreator"));
const BooksIndex_1 = __importDefault(require("../book/BooksIndex"));
const BookShow_1 = __importDefault(require("../book/BookShow"));
const ArticleCreator_1 = __importDefault(require("../article/ArticleCreator"));
const ArticlesIndex_1 = __importDefault(require("../article/ArticlesIndex"));
const ArticleShow_1 = __importDefault(require("../article/ArticleShow"));
const ArticleEditor_1 = __importDefault(require("../article/ArticleEditor"));
const CategoryCreator_1 = __importDefault(require("../category/CategoryCreator"));
const CategoriesIndex_1 = __importDefault(require("../category/CategoriesIndex"));
const CategoryShow_1 = __importDefault(require("../category/CategoryShow"));
const CategoryEditor_1 = __importDefault(require("../category/CategoryEditor"));
const BookEdit_1 = __importDefault(require("../book/BookEdit"));
function AllowedRoutes(props) {
    function isLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.getAdmin(); }), (data) => props.refreshAdmin(data), 'isLoggedIn');
        });
    }
    react_1.default.useEffect(() => {
        if (window.admin) {
            props.refreshAdmin(window.admin);
        }
        else if (props.admin == null) {
            isLoggedIn();
        }
        // console.log('props', props)
    }, [props.admin]);
    if (props.admin)
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TopMenue_1.default, null),
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'my-2 min-vh-100' },
                react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.dashboard(), component: Home_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.pageCreator(), component: PageCreator_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.pagesIndex(), component: PagesIndex_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.pageShow(), component: PageShow_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.pageEdit(), component: PageEditor_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.bookCreator(), component: BookCreator_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.booksIndex(), component: BooksIndex_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.bookShow(), component: BookShow_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.bookEdit(), component: BookEdit_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.articleCreator(), component: ArticleCreator_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.articlesIndex(), component: ArticlesIndex_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.articleShow(), component: ArticleShow_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.articleEdit(), component: ArticleEditor_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.categoryCreator(), component: CategoryCreator_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.categoriesIndex(), component: CategoriesIndex_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.categoryShow(), component: CategoryShow_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: URLs_2.Routes.categoryEdit(), component: CategoryEditor_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { component: NotFound_1.default }))),
            react_1.default.createElement(Footer_1.default, null));
    else
        return react_1.default.createElement(LoginPage_1.default, null);
}
const stateActions_1 = require("../redux/stateActions");
const react_redux_1 = require("react-redux");
const Footer_1 = __importDefault(require("../components/Footer"));
const mapStateToProps = state => {
    return {
        admin: state.state.admin,
        allowedRoutes: state.state.allowedRoutes,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        refreshAdmin: (admin) => dispatch((0, stateActions_1.refreshAdmin)(admin)),
        setAllowedRoutes: (allowedRoutes) => dispatch((0, stateActions_1.setAllowedRoutes)(allowedRoutes)),
    };
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(AllowedRoutes);
